app.views.auth = app.views.base.extend({
  init: function init(data) {},
  initPostMessageEventListener: function initPostMessageEventListener() {
    var $login = $('#Login');
    var _this = this;
    window.addEventListener('message', function (event) {
      _this._resizeHandler($login, 'LoginIFrame', event);
      _this._redirectHandler($login, 'LoginIFrame', event);
    });
  },
  initPasswordRecoverIframeEventListener: function initPasswordRecoverIframeEventListener() {
    var $passwordRecovery = $('#PasswordRecovery');
    var _this = this;
    window.addEventListener('message', function (event) {
      _this._resizeHandler($passwordRecovery, 'PasswordRecoveryIFrame', event);
      _this._redirectHandler($passwordRecovery, 'PasswordRecoveryIFrame', event);
    });
  },
  initPasswordResetIframeEventListener: function initPasswordResetIframeEventListener() {
    var $passwordReset = $('#PasswordReset');
    var _this = this;
    window.addEventListener('message', function (event) {
      _this._resizeHandler($passwordReset, 'PasswordResetIFrame', event);
      _this._redirectHandler($passwordReset, 'PasswordResetIFrame', event);
    });
  },
  _resizeHandler: function _resizeHandler(elm, iframeId, event) {
    if (event.origin === elm.data('origin') && event.data.type === 'resize') {
      var $iFrame = $('#' + iframeId);
      if (!$iFrame) return;
      $iFrame.css('height', event.data.height);
    }
  },
  _redirectHandler: function _redirectHandler(elm, iframeId, event) {
    if (event.origin === elm.data('origin') && event.data.type === 'redirect') {
      var $iFrame = $('#' + iframeId);
      if (!$iFrame) return;
      window.location = event.data.url;
    }
  }
});